import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';

const EmptyState = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="text-center py-8 sm:py-12 px-3 sm:px-4 md:px-6"
    >
      <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-4 bg-primary/10 rounded-full flex items-center justify-center border border-primary/10">
        <Calendar className="w-7 h-7 sm:w-8 sm:h-8 text-primary" />
      </div>
      
      <h3 className="text-base sm:text-lg font-semibold text-primary-dark mb-2 sm:mb-3">
        No tasks scheduled for today
      </h3>
      
      <p className="text-neutral-500 text-xs sm:text-sm max-w-sm mx-auto">
        Enjoy your day off! Check back tomorrow for new tasks and learning opportunities.
      </p>
    </motion.div>
  );
};

export default EmptyState;
